import React, { ButtonHTMLAttributes, Fragment, ReactNode } from "react";

type ButtonPrimaryProps = ButtonHTMLAttributes<HTMLButtonElement> & {
  text: ReactNode;
  size?: string;
  type?: "button" | "submit" | "reset";
};

export const ButtonPrimary: React.FC<ButtonPrimaryProps> = ({
  size = "smallxs",
  text,
  type = "button",
  ...props
}) => (
  <Fragment>
    <button
      {...props}
      type={type}
      className={`rounded-md bg-primary-800 ${
        size === "small-xs"
          ? "px-2 py-1 text-sm"
          : size === "medium"
            ? "px-2.5 py-1.5 text-sm"
            : size === "large"
              ? "px-3 py-2 text-sm"
              : size === "extraLarge"
                ? "px-3.5 py-2.5 text-sm"
                : "px-2 py-1 text-xs"
      } font-semibold text-white shadow-sm hover:bg-primary-400 hover:text-black focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary-500`}
    >
      {text}
    </button>
  </Fragment>
);
